import { IonRouterLink } from '@ionic/react'
import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useUser from '../../contexts/hooks/useUser'
import { ModalContext } from '../../contexts/ModalContext'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import PublicWrapper from '../../wrappers/publicWrapper/PublicWrapper'

const ObjectSelector: React.FC = () => {
	const { objectOptions } = useContext(ObjectContext)
	const { insertModal } = useContext(ModalContext)

	const history = useHistory()
	const { user, setUser } = useUser()
	const { t } = useTranslation('pages_objectSelector')

	useEffect(() => {
		if (!user) {
			history.replace('/')
		}
	}, [user, history])

	if (!user) return null

	return (
		<PublicWrapper id='contract-selector'>
			<h1 className='text-text-dark dark:text-white'>{t('ensisijainenKohde')}</h1>
			<div className='contract-list'>
				{objectOptions.map(objectOption => (
					<IonRouterLink
						key={objectOption.id}
						onClick={() => {
							insertModal('onboarding')

							setUser({
								selectedObject: objectOption.id,
							})
						}}
						routerLink={`/`}
						id={`${objectOption.id}`}
						className='contract-option border-2 border-brand-primary-100-light dark:border-brand-primary-100-dark text-brand-primary-100-light dark:text-brand-primary-100-dark'
					>
						{objectOption.streetAddress} {objectOption.houseNumber}
					</IonRouterLink>
				))}
			</div>
		</PublicWrapper>
	)
}
export default ObjectSelector
